module.exports = __webpack_public_path__ + "img/Diamond.d85039a9.png";